import { render } from "./GamesPlayed.vue?vue&type=template&id=621b9022&scoped=true&bindings={\"games\":\"data\"}"
import script from "./GamesPlayed.vue?vue&type=script&lang=js"
export * from "./GamesPlayed.vue?vue&type=script&lang=js"

import "./GamesPlayed.vue?vue&type=style&index=0&id=621b9022&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-621b9022"

export default script